<template>
    
    <b-row>
        <b-col md="4" cols="12">
            <ShowSessionMinutesFile :data='data.meeting_minute_id' message="التي تم خلالها الموافقة على تحديد موعد اجتماع الهئية العامة"/>
        </b-col>
        <b-col md="4" cols="12">
            <info-card
            label="موعد الاجتماع الأول"
            :value="data.first_meeting_date"
            />
        </b-col> 
        <b-col md="4" cols="12">
            <info-card
            label="موعد الاجتماع الثاني"
            :value="data.second_meeting_date"
            />
        </b-col> 
        <b-col md="4" cols="12">
            <info-card
            label="مكان عقد الاجتماع"
            :value="data.meeting_location"
            />
        </b-col>    
        <b-col md="4" cols="12">
            <info-card
            label="عدد أعضاء الهيئة العامة"
            :value="data.general_authority_members_count"
            />
        </b-col>    
        <b-col md="4" cols="12">
            <info-card
            label="عدد أعضاء الهيئة العامة الذين يحق لهم الحضور"
            :value="data.general_authority_members_who_can_attend_count"
            />
        </b-col>    
        <b-col md="4" cols="12">
            <info-card
            label="جدول الاحتماع"
            :value="data.business_schedule"
            />
        </b-col>       
        <b-col md="4" cols="12" v-if="data.does_meeting_include_nomination_of_board_members === 'true'">
            <info-card
            label="أسماء المرشحين لعضوية مجلس الإدارة"
            :value="data.directors_board_candidates_membership_names"
            />
        </b-col>      
    </b-row>
  </template>
  
  <script>
  import { BCard , BImg , BCol , BRow , VBToggle , VBTooltip , BButton } from "bootstrap-vue";
  import ShowSessionMinutesFile from './ShowSessionMinutesFile.vue'
  import InfoCard from "@/components/InfoCard.vue";

  export default {
    components: {
        BCard, BImg , BCol , InfoCard , BRow , BButton, ShowSessionMinutesFile
    },
    data() {
        return {
            file: '',
        }
    },
    props: {
        data :Object ,
    },
    
    directives: {
        "b-toggle": VBToggle,
        "b-tooltip": VBTooltip,
    },
  };
  </script>